import {MutableRefObject, useCallback, useRef} from 'react';

export const useRefSrollIntoView = <T extends HTMLElement>(delay: number): [MutableRefObject<T | null>, () => void] => {
  const ref = useRef<T>(null);

  const scrollIntoView = useCallback(
    () =>
      setTimeout(() => {
        ref.current?.scrollIntoView({behavior: 'smooth', block: 'center'});
      }, 100),
    [],
  );

  return [ref, scrollIntoView];
};
